import { getFormOnlyFields, SERVICING_ROLE_FIELDS } from './portfolioTypeDependentFields';

const getAllFormOnlyFields = (): string[] => [...getFormOnlyFields(), ...SERVICING_ROLE_FIELDS];

export const withoutFormOnlyFields = (values: object) => {
  const formOnlyFields = getAllFormOnlyFields();
  return Object.fromEntries(Object.entries(values).filter(([field]) => !formOnlyFields.includes(field)));
};
